// Mappa delle chiavi di errore ai messaggi formali tradotti
export const getFormalForbiddenMessage = (key: string) => {
    switch (key) {
        case "TIPO_DI_UTENTE_PRIVATO_O_AZIENDA_O_ASSOCIAZIONE_NON_DEFINITO":
            return "Tipologia di utente non definita. La preghiamo di aggiornare i dati del profilo o di contattare il supporto per ulteriori informazioni.";
        case "UTENTE_NON_ABILITATO":
            return "Il suo account non è abilitato. Contatti il supporto per maggiori dettagli.";
        case "UTENTE_CANCELLATO":
            return "Il suo account risulta cancellato. Per assistenza si rivolga al supporto.";
        case "UTENTE_CON_ASSOCIAZIONE_CANCELLATA":
            return "L'associazione collegata al suo profilo risulta cancellata. Contatti l'assistenza per chiarimenti.";
        case "UTENTE_CON_POSIZIONE_DI_ASSOCIAZIONE_NULLA":
            return "Non risultano posizioni attive nella sua associazione. Si prega di verificare con l'amministratore dell'associazione.";
        case "UTENTE_RIMOSSO_DALLA_ASSOCIAZIONE_O_SENZA_ASSOCIAZIONE":
            return "Non risulta associato ad alcuna associazione o è stato rimosso. Per ulteriori dettagli si rivolga al supporto.";
        case "UTENTE_NON_ANCORA_APPROVATO_DALLA_ASSOCIAZIONE":
            return "La sua appartenenza all'associazione necessita ancora di approvazione. Attenda la convalida da parte dell'associazione.";
        case "AZIENDA_O_ASSOCIAZIONE_NON_CONVENZIONATA":
            return "La sua azienda o associazione non risulta convenzionata. Verifichi con il supporto.";
        case "AZIENDA_O_ASSOCIAZIONE_CON_POSIZIONE_DI_APPROVAZIONE_NULLA":
            return "La sua azienda o associazione non ha una posizione di approvazione valida. Si prega di contattare il supporto.";
        case "AZIENDA_O_ASSOCIAZIONE_BLOCCATA_DALL_AMMINISTRATORE":
            return "La sua azienda o associazione è stata bloccata dall'amministratore. Per maggiori dettagli si rivolga al supporto.";
        case "AZIENDA_O_ASSOCIAZIONE_NON_ANCORA_APPROVATA_DALL_AMMINISTRATORE":
            return "La sua azienda o associazione è in attesa di approvazione da parte dell'amministratore.";
        case "FirstRequest":
            return "forbidden.kyc.FirstRequest";
        case "UnderVerification":
            return "forbidden.kyc.UnderVerification";
        case "RequestForAdditionalDocuments":
            return "forbidden.kyc.RequestForAdditionalDocuments";
        case "NotApproved":
            return "forbidden.kyc.NotApproved";
        default:
            return typeof key === "string" ? key : "Accesso negato";
    }
};